// Libraries
import { NgModule }       from '@angular/core';
import { CommonModule }   from '@angular/common';

// Components
import { PaginationComponent } from './pagination.component';

/**
 * `PaginationModule` defines a module manage pagination.
 */
@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    PaginationComponent,
  ],
  providers: [
  ],
  exports: [
    PaginationComponent
  ]
})
export class PaginationModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/woopa-ui/pagination/pagination.module.ts